import { createSelector } from '@reduxjs/toolkit';

import { TrussEnvelopeInsertionInformation } from '../../library/layout-geometry/truss-envelopes/insertion-information';
import { RootState } from '..';
import { getGeometricEcosystemForTrussEnvelopeInsertion } from './layoutGeometricEcosystemSelectors';
import { getPickingObjectInfo } from './pickingSelectors';
import { getActualPointSnappingSettings } from './snappingSettingsSelectors';

export const getTrussEnvelopeInsertionInformation = createSelector(
  (state: RootState) => state.application.insertingObjectInfo,
  getPickingObjectInfo,
  (state: RootState) => state.layout.trussEnvelopeInsertionSettings,
  getActualPointSnappingSettings,
  (state: RootState) => state.application.snappingLevel,
  getGeometricEcosystemForTrussEnvelopeInsertion,

  (
    insertingObjectInfo,
    pickingInfo,
    settings,
    snappingSettings,
    snappingLevel,
    ecosystem,
  ): TrussEnvelopeInsertionInformation | null => {
    if (insertingObjectInfo?.type !== 'trussEnvelope' || ecosystem == null || snappingSettings == null) return null;

    return new TrussEnvelopeInsertionInformation({
      settings,
      snappingSettings,
      snappingLevel,
      ecosystem,
      insertionData: insertingObjectInfo.data,
      pickingInfo,
    });
  },
);
